import api from "../../index";

export const    GetAllUsersApi = (params) => api.get(`Admin/GetAll-UserList?${params}`);
export const GetAllNotificationsApi = (params) => api.get(`Notification/GetAllMessages?${params}`);
export const DeleteNotificationsApi = (Id) => api.delete(`Notification/ClearAllNotifications/${Id}`);
export const AddNotificationApi = (data, headers) => api.post('notification/sendNotification', data, headers);